import dayjs from 'dayjs'
import { useRef, useState } from 'react'

import { timeDayjsToHhMm, timeHhMmSsToDayjs } from '@/shared/lib/timeHelper'
import { Box, styled } from '@mui/material'
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium'

import { TimePicker } from '../../TimePicker/TimePicker'

type TimeEditCellProps = GridRenderEditCellParams & {
  required?: boolean
  placeholder?: string
  format?: string
}

export const TimeEditCell: React.FC<TimeEditCellProps> = ({
  id,
  field,
  value,
  required,
  placeholder = 'HH:mm',
  format = 'HH:mm',
  colDef,
  ...props
}) => {
  const apiRef = useGridApiContext()
  const inputRef = useRef<HTMLInputElement>()
  const [timeValue, setTimeValue] = useState(timeHhMmSsToDayjs(value || '00:00'))

  const handleValueChange = (newValue: dayjs.Dayjs | null) => {
    if (!newValue) return

    setTimeValue(newValue)

    // Convert value back to string format for grid data
    const newTimeString = timeDayjsToHhMm(newValue)

    apiRef.current.setEditCellValue({
      id,
      field,
      value: newTimeString,
      debounceMs: 200,
    })
  }

  return (
    <StyledTimeEditCell {...props}>
      <StyledTimePicker
        value={timeValue}
        onChange={handleValueChange}
        onAccept={handleValueChange}
        format={format}
        views={['hours', 'minutes']}
        slotProps={{
          textField: {
            variant: 'standard',
            placeholder,
            inputRef,
            fullWidth: true,
            size: 'small',
          },
        }}
      />
    </StyledTimeEditCell>
  )
}

const StyledTimeEditCell = styled(Box)`
  width: 100%;
  height: 100%;
  padding: ${props => props.theme.spacing(0, 1)};
  display: flex;
  align-items: center;

  .MuiInputBase-root {
    &::before, &::after {
      display: none !important;
    }
  }

  .MuiInputBase-input {
    padding: 0;
    height: auto;
  }
`

const StyledTimePicker = styled(TimePicker)`
  .MuiInputAdornment-positionEnd {
    margin-left: 0;
  }

  .MuiIconButton-root {
    padding: 0;
    margin: 0;
    background-color: transparent;
  }
`